import {ReactComponent as GithubIcon} from 'assets/img/github.svg';
import './styles.css';

function Navbar(){

    return(
        <header>
        <nav className="container">
            <div className="dsmovie-nav-content">
                <h1>Ticket.com</h1>
                <a href="https://github.com/iMortlaSuap" target="_blank" rel="noreferrer">
                    <div className="dsmovie-contact-container">
                        <GithubIcon />
                        <p className="dsmovie-contact-link">/RubensJr</p>
                    </div>
                </a>
            </div>
        </nav>
    </header>
    )
}

export default Navbar